import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQSection = () => {
  const faqs = [
    {
      question: "What housekeeping organization services do you offer in Michigan?",
      answer: "We provide comprehensive housekeeping organization systems including daily routine optimization, cleaning supply organization, laundry systems, and kitchen efficiency setups. Our ADHD-friendly systems make daily maintenance effortless for busy Michigan families."
    },
    {
      question: "How do you help with real estate prep and staging in Michigan?",
      answer: "Our real estate prep service includes decluttering, depersonalizing, optimizing storage, and creating market-ready appeal. We've helped Michigan homeowners sell faster and for higher prices by transforming spaces that showcase their home's best features."
    },
    {
      question: "What makes your ADHD organizing systems different?",
      answer: "Our ADHD-friendly systems use visual cues, simple maintenance routines, and neurodivergent-friendly organization strategies. We create sustainable systems that work with how your brain processes information, reducing overwhelm and decision fatigue."
    },
    {
      question: "Which Southwest Michigan areas do you serve?",
      answer: "We serve Buchanan, Niles, St. Joseph, Benton Harbor, Berrien Springs, Stevensville, Bridgman, New Buffalo, Dowagiac, Edwardsburg, and all surrounding Southwest Michigan communities. Our team travels throughout Berrien County and beyond to bring professional organization services to your home."
    },
    {
      question: "How long does a typical home organization project take?",
      answer: "Projects range from same-day emergency decluttering to multi-week whole-home transformations. Our popular 72-hour Home Reset completely transforms your space in just 3 days, while ongoing maintenance packages ensure lasting results."
    },
    {
      question: "Do you offer same-day organizing services?",
      answer: "Yes! Our Same-Day Emergency service is perfect for last-minute guests, real estate showings, or when you need immediate results. We can declutter and organize key areas in 4-8 hours for instant transformation."
    },
    {
      question: "What's included in your consultation?",
      answer: "Your free consultation includes space assessment, custom organization plan, timeline discussion, and transparent pricing. We'll discuss your specific needs whether it's housekeeping systems, real estate prep, or ADHD-friendly organization."
    }
  ];

  return (
    <section className="py-20 bg-background">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-serif font-light mb-6">
            Frequently Asked Questions
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            Everything you need to know about our housekeeping, real estate prep, and ADHD organizing services
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, index) => (
              <AccordionItem key={index} value={`item-${index}`} className="border-border">
                <AccordionTrigger className="text-left hover:text-primary">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground leading-relaxed">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
          
          {/* FAQ Schema for SEO */}
          <script 
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify({
                "@context": "https://schema.org",
                "@type": "FAQPage",
                "mainEntity": faqs.map((faq) => ({
                  "@type": "Question",
                  "name": faq.question,
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": faq.answer
                  }
                }))
              })
            }}
          />
        </div>
      </div>
    </section>
  );
};

export default FAQSection;